import cx from 'classnames';
import Link, { LinkProps } from 'next/link';
import { AnchorHTMLAttributes } from 'react';

type MenuLinkSize = 'big' | 'small';

type MenuLinkProps = {
  children: React.ReactNode;
  size?: MenuLinkSize;
  className?: string;
  href: string;
  rel?:
    | AnchorHTMLAttributes<HTMLAnchorElement>['rel']
    | AnchorHTMLAttributes<HTMLAnchorElement>['rel'][];
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
} & LinkProps;

const SIZE_MAP: Record<MenuLinkSize, string> = {
  big: 'text-xl font-semibold border border-transparent focus:border-grey-90',
  small: 'text-sm font-medium ',
};

const baseClasses =
  'block w-full text-heading rounded-md px-4 py-2   transition-all duration-150 ease-in-out hover:bg-heading/10';

const MenuLink = ({
  href,
  children,
  size = 'small',
  className,
  rel,
  target,
}: MenuLinkProps) => {
  if (!href) {
    return null;
  }
  const sizeClasses = SIZE_MAP[size];
  const isExternalLink = href.startsWith('http') || href.startsWith('www');

  const normalizedRel = Array.isArray(rel) ? rel.join(' ') : rel;

  if (isExternalLink) {
    return (
      <a
        href={href}
        className={cx(baseClasses, sizeClasses, className)}
        rel={normalizedRel}
        target={target}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      href={href}
      className={cx(baseClasses, sizeClasses, className)}
      target={target}
      rel={normalizedRel}
    >
      {children}
    </Link>
  );
};

export default MenuLink;
